import React from 'react';
import "./styles.sass";
import { createPortal } from "react-dom";

export const LogoutPopup = ({ onClose, onLogout, title = "Logout", description = "Are you sure you want to logout from your account?", btnText = "Logout" }) => {
  const mountNode = document.getElementById('logout-pop') || document.body;

  return createPortal(
    <div className="logout_overlay_wrapper" onClick={onClose}>
      <div className="logout_popup_container" onClick={(e) => e.stopPropagation()}>
        <button className="logout_close_btn" onClick={onClose} aria-label="Close">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="logout_logo_badge">
          <div className="logout_logo_inner">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
          </div>
        </div>

        <div className="logout_popout_content">
          <h4>{title}</h4>
          <p>{description}</p>
        </div>

        <div className="logout_actions_row">
          <button className="logout_cancel_btn" onClick={onClose}>
            Cancel
          </button>
          <button className="logout_confirm_btn" onClick={onLogout}>
            {btnText}
          </button>
        </div>
      </div>
    </div>,
    mountNode
  );
};